import React from 'react';
import Breadcrumbs from '@/widgets/breadcrumbs';
import EditSolicitationProvider from '../../components/apis/edit-solicitation-provider';
import OpenPeriod from './open-period';
import { breadcrumbsPath } from '../../utils/solicitation-helpers';

const OpenPeriodWrapper = () => {
  return (
    <div
      className="grid-col margin-bottom-8"
      data-testId="open-periods-wrapper"
    >
      <Breadcrumbs current="Edit Solicitation" path={breadcrumbsPath} />
      <EditSolicitationProvider>
        <OpenPeriod />
      </EditSolicitationProvider>
    </div>
  );
};

export default OpenPeriodWrapper;
